/* UI safeguard only. Server checkout must independently have no accepting payment method. */
(() => {
  if (!document.body.hasAttribute('data-fm-browse-only')) return;
  function purchasePath(value) {
    try { return /^\/(?:cart\/add(?:\.js)?|checkout)(?:\/|$)/.test(new URL(value, location.origin).pathname); }
    catch { return false; }
  }
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const submitter = event.submitter;
    if (purchasePath(form.action) || submitter?.name === 'checkout' || submitter?.name === 'add') {
      event.preventDefault();
      event.stopImmediatePropagation();
      document.querySelector('.fm-browse-banner')?.focus();
    }
  }, true);
  document.addEventListener('click', event => {
    const link = event.target instanceof Element ? event.target.closest('a[href]') : null;
    if (link && purchasePath(link.href)) {
      event.preventDefault();
      event.stopImmediatePropagation();
      document.querySelector('.fm-browse-banner')?.focus();
    }
  }, true);
})();
